<svg-avatar
  [displayName]="userName"
  [bgColor]="bgColor"
  [iconColor]="iconColor"
  [e2e]="e2e"
></svg-avatar>
